// Produktgalerie Desktop als Slider (ab 1200 px), Einstellung "Galerie Desktop" (settings.su_gallery_desktop).
// Baut auf der Masonry-Liste des Themes auf (gallery.js, .wt-masonry__wrapper): Die Liste wird per CSS (assets/su-gallery.css)
// zur waagerechten Spur mit Scroll-Snap. Dazu Pfeile (beim Hover), Ziehen mit der Maus, Pfeiltasten, Vorschaubilder unten,
// Zaehler, Grossansicht per Klick (PhotoSwipe aus dem Theme) und eine passend grosse Bildversion (sizes je Anzeigegroesse).
// Unter 1200 px laeuft unveraendert der Swiper des Themes. Wechselt die Bildliste (Farbe/Variante), springt die Galerie
// auf das erste Bild.
(() => {
  const root = document.documentElement;
  if (root.dataset.suGallery !== 'slider') return;
  const me = document.currentScript;
  const mq = window.matchMedia('(min-width: 1200px)');
  const de = false; // Full English (19.10.2026)
  const TXT = de
    ? { prev: 'Vorheriges Bild', next: 'Nächstes Bild', thumb: 'Bild', of: 'von' }
    : { prev: 'Previous image', next: 'Next image', thumb: 'Image', of: 'of' };
  const chevron = (d) => `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;

  function init(section) {
    const gallery = section.querySelector('[data-gallery]');
    if (!gallery) return;
    let track = null;
    let idx = 0;
    let ui = null;
    let dragged = false;
    let lightbox = null;

    const slides = () => (track ? Array.from(track.children).filter((li) => li.matches('[data-swiper-slide]')) : []);
    const width = () => (track ? track.clientWidth || 1 : 1);

    function buildUi() {
      ui?.wrap.remove();
      const wrap = document.createElement('div');
      wrap.className = 'su-gal__ui';
      wrap.innerHTML = `
        <button type="button" class="su-gal__nav su-gal__nav--prev" aria-label="${TXT.prev}">${chevron('M15 5l-7 7 7 7')}</button>
        <button type="button" class="su-gal__nav su-gal__nav--next" aria-label="${TXT.next}">${chevron('M9 5l7 7-7 7')}</button>
        <div class="su-gal__bar"><div class="su-gal__thumbs"></div></div>
        <div class="su-gal__count" aria-live="polite"></div>
        <div class="su-gal__progress" aria-hidden="true"><i></i></div>`;
      gallery.appendChild(wrap);
      const thumbs = wrap.querySelector('.su-gal__thumbs');
      slides().forEach((li, i) => {
        const img = li.querySelector('img');
        const video = li.querySelector('video');
        let src = img ? (img.currentSrc || img.src) : (video ? video.getAttribute('poster') : '');
        if (src) {
          try { const u = new URL(src, location.href); u.searchParams.set('width', '200'); src = u.href; } catch (e) { /* Pfad unveraendert */ }
        }
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'su-gal__thumb';
        b.setAttribute('aria-label', `${TXT.thumb} ${i + 1} ${TXT.of} ${slides().length}`);
        b.innerHTML = src ? `<img src="${src}" alt="" loading="lazy" draggable="false">` : '';
        b.addEventListener('click', () => go(i));
        thumbs.appendChild(b);
      });
      wrap.querySelector('.su-gal__nav--prev').addEventListener('click', () => go(idx - 1));
      wrap.querySelector('.su-gal__nav--next').addEventListener('click', () => go(idx + 1));
      ui = { wrap, thumbs, prev: wrap.querySelector('.su-gal__nav--prev'), next: wrap.querySelector('.su-gal__nav--next'), count: wrap.querySelector('.su-gal__count'), bar: wrap.querySelector('.su-gal__progress i') };
      if (slides().length < 2) wrap.hidden = true;
    }

    function mark() {
      if (!ui) return;
      const n = slides().length;
      ui.prev.hidden = idx <= 0;
      ui.next.hidden = idx >= n - 1;
      ui.count.textContent = `${idx + 1} / ${n}`;
      // Fortschrittsleiste wie Skims (Vito 19.10.2026): Abschnitt = 1/n der Breite, steht beim aktuellen Bild
      if (ui.bar && n) { ui.bar.style.width = `${100 / n}%`; ui.bar.style.transform = `translateX(${idx * 100}%)`; }
      Array.from(ui.thumbs.children).forEach((b, i) => b.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      const t = ui.thumbs.children[idx];
      if (t) {
        const l = t.offsetLeft - (ui.thumbs.clientWidth - t.offsetWidth) / 2;
        ui.thumbs.scrollTo({ left: l, behavior: 'smooth' });
      }
      // Nachbarbilder vorladen, damit beim Weiterklicken nichts leer ist
      [idx - 1, idx + 1, idx + 2].forEach((i) => { const img = slides()[i]?.querySelector('img'); if (img) img.loading = 'eager'; });
    }

    function go(i, smooth = true) {
      const n = slides().length;
      if (!track || !n) return;
      idx = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: idx * width(), behavior: smooth ? 'smooth' : 'auto' });
      mark();
    }

    // Seitenverhaeltnis Breite/Hoehe: aus --slide-ratio der Galerie, sonst aus dem geladenen Bild
    const ratio = (li, img) => parseFloat(li.style.getPropertyValue('--slide-ratio')) || (img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 0.8);

    // Bildgroesse: sichtbare Breite bei object-fit: cover, mindestens 1,5 Bildpunkte je Anzeigepunkt
    function setSizes() {
      if (!track) return;
      const w = track.clientWidth;
      const h = track.clientHeight;
      // Erst messen, wenn das Slider-CSS greift (vorher ist die Spalte die lange Bildliste)
      if (w < 200 || h < 200 || w > window.innerWidth || h > window.innerHeight + 4) return;
      const factor = Math.max(1, 1.5 / (window.devicePixelRatio || 1));
      slides().forEach((li) => {
        const img = li.querySelector('img');
        if (!img) return;
        const r = ratio(li, img);
        img.sizes = `${Math.ceil(Math.max(w, h * r) * factor)}px`;
      });
    }

    function onScroll() {
      const f = track.scrollLeft / width();
      if (ui && ui.bar) ui.bar.style.transform = `translateX(${Math.max(0, f) * 100}%)`;
      const i = Math.round(f);
      if (i !== idx) { idx = i; mark(); }
    }

    // Ziehen mit der Maus (Touch und Trackpad scrollen nativ)
    let drag = null;
    function onDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
      dragged = false;
    }
    function onMove(e) {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) {
        drag.moved = true;
        section.classList.add('su-gal--drag');
      }
      if (drag.moved) { track.scrollLeft = drag.left - dx; e.preventDefault(); }
    }
    function onUp(e) {
      if (!drag) return;
      const d = drag;
      drag = null;
      if (!d.moved) return;
      dragged = true;
      const dx = e.clientX - d.x;
      const base = Math.round(d.left / width());
      const step = Math.abs(dx) > width() * 0.12 ? (dx < 0 ? 1 : -1) : 0;
      go(base + step);
      // Snap erst wieder an, wenn die Bewegung steht, sonst springt die Spur zum naechsten Rastpunkt
      let done = false;
      const end = () => { if (done) return; done = true; section.classList.remove('su-gal--drag'); };
      track.addEventListener('scrollend', end, { once: true });
      setTimeout(end, 700);
    }

    // Trackpad/Kipprad waagerecht: ein Wisch = ein Bild. Chrome entscheidet mit dem ersten Ereignis einer Geste, ob sie
    // abgefangen wird; senkrechte Gesten gehen unveraendert an die Seite. Nachlaufende Ereignisse (Schwung) werden
    // geschluckt, bis 200 ms Ruhe ist.
    let wAcc = 0;
    let wLock = false;
    let wTimer = 0;
    function onWheel(e) {
      const k = e.deltaMode === 1 ? 16 : 1;
      const dx = e.deltaX * k;
      if (Math.abs(dx) <= Math.abs(e.deltaY * k) && !wLock && !wAcc) return;
      e.preventDefault();
      clearTimeout(wTimer);
      wTimer = setTimeout(() => { wAcc = 0; wLock = false; }, 200);
      if (wLock) return;
      wAcc += dx;
      if (Math.abs(wAcc) > 24) { wLock = true; go(idx + (wAcc > 0 ? 1 : -1)); }
    }

    // Grossansicht (PhotoSwipe aus dem Theme), nur Bilder. Oeffnet aus dem angeklickten Bild heraus (Zoom-Animation),
    // Klick/Doppeltipp und Mausrad zoomen, Zoomstufe steht unten rechts, mobil Wischen und nach unten ziehen zum Schliessen.
    const allSlides = () => Array.from(gallery.querySelectorAll('[data-swiper-container] > [data-swiper-slide]'));
    const ICN = (d) => `<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32"><path d="${d}" fill="none" stroke="#141413" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    async function zoom(i) {
      const list = allSlides();
      const items = [];
      let start = 0;
      list.forEach((li, k) => {
        const img = li.querySelector('img');
        if (!img || li.querySelector('model-element')) return;
        if (k === i) start = items.length;
        let src = img.currentSrc || img.src;
        try { const u = new URL(src, location.href); u.searchParams.set('width', '2048'); src = u.href; } catch (e) { /* unveraendert */ }
        items.push({ src, width: 2048, height: Math.round(2048 / ratio(li, img)), alt: img.alt, k, element: li, thumbCropped: !!track });
      });
      if (!items.length || !me?.dataset.pswpLightbox) return;
      const { default: Lightbox } = await import(me.dataset.pswpLightbox);
      lightbox?.destroy();
      lightbox = new Lightbox({
        dataSource: items,
        pswpModule: () => import(me.dataset.pswp),
        bgOpacity: 1,
        showHideAnimationType: 'zoom',
        showAnimationDuration: 420,
        hideAnimationDuration: 360,
        zoomAnimationDuration: 380,
        easing: 'cubic-bezier(.2,.7,.2,1)',
        wheelToZoom: true,
        // Zoomstufen relativ zum eingepassten Bild (PhotoSwipe-Zahlen beziehen sich sonst auf Originalpixel): Klick 2x, Rad bis 3x
        secondaryZoomLevel: (z) => z.fit * 2,
        maxZoomLevel: (z) => z.fit * 3,
        closeOnVerticalDrag: true,
        closeSVG: ICN('M9 9l14 14M23 9L9 23'),
        zoomSVG: ICN('M14 5a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM20.5 20.5L27 27M10 14h8M14 10v8'),
        arrowPrevSVG: ICN('M19 7l-9 9 9 9'),
        arrowNextSVG: ICN('M13 7l9 9-9 9'),
        errorMsg: '',
      });
      lightbox.on('change', () => {
        const p = lightbox.pswp;
        if (!p) return;
        const k = items[p.currIndex].k;
        if (track) go(k, false);
        else section.gallerySwiper?.slideTo(k);
      });
      // Zoomstufe unten rechts: 1x = eingepasst, erscheint bei Vergroesserung
      lightbox.on('uiRegister', () => {
        lightbox.pswp.ui.registerElement({
          name: 'su-zoomlevel', className: 'su-pswp__zoom', appendTo: 'root',
          onInit: (el, pswp) => {
            pswp.on('zoomPanUpdate', ({ slide }) => {
              const z = slide.currZoomLevel / slide.zoomLevels.fit;
              el.textContent = (Math.round(z * 10) / 10).toString().replace('.', ',') + '\u00d7';
              el.classList.toggle('is-on', z > 1.02);
            });
          },
        });
      });
      lightbox.init();
      lightbox.loadAndOpen(start);
    }

    function onClick(e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; return; }
      const li = e.target.closest('[data-swiper-slide]');
      if (!li || !li.querySelector('img') || e.target.closest('button, video, model-element')) return;
      e.preventDefault();
      zoom(allSlides().indexOf(li));
    }

    // Mobil und Tablet (Swiper des Themes): Tippen oeffnet die Grossansicht, Wischen nicht
    let tap = null;
    gallery.addEventListener('pointerdown', (e) => { if (!track) tap = [e.clientX, e.clientY]; });
    gallery.addEventListener('click', (e) => {
      if (track || !tap) return;
      const moved = Math.hypot(e.clientX - tap[0], e.clientY - tap[1]) > 8;
      tap = null;
      if (moved) return;
      onClick(e);
    });

    function attach() {
      const t = gallery.querySelector('.wt-masonry__wrapper');
      if (!mq.matches || !t) { detach(); return; }
      if (track === t && section.classList.contains('su-gal')) { setSizes(); return; }
      detach();
      track = t;
      section.classList.add('su-gal');
      track.querySelectorAll('img').forEach((img) => { img.draggable = false; });
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('pointerdown', onDown);
      track.addEventListener('click', onClick, true);
      track.addEventListener('wheel', onWheel, { passive: false });
      buildUi();
      ro.observe(track);
      idx = 0;
      go(0, false);
    }

    function detach() {
      if (track) {
        ro.unobserve(track);
        track.removeEventListener('scroll', onScroll);
        track.removeEventListener('pointerdown', onDown);
        track.removeEventListener('wheel', onWheel);
        track.removeEventListener('click', onClick, true);
        track.scrollLeft = 0;
      }
      section.classList.remove('su-gal', 'su-gal--drag');
      ui?.wrap.remove();
      ui = null;
      track = null;
    }

    // Groesse der Spur bekannt oder geaendert: Bildgroesse neu setzen und auf dem aktuellen Bild bleiben
    const ro = new ResizeObserver(() => { setSizes(); if (track) track.scrollLeft = idx * width(); });

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('keydown', (e) => {
      if (!track || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target.closest && e.target.closest('input, textarea, select, [contenteditable="true"], [role="dialog"], dialog')) return;
      if (document.querySelector('.pswp--open')) return;
      const r = section.getBoundingClientRect();
      if (r.bottom < 80 || r.top > window.innerHeight - 80) return;
      e.preventDefault();
      go(idx + (e.key === 'ArrowRight' ? 1 : -1));
    });
    window.addEventListener('resize', () => { attach(); if (track) go(idx, false); });

    // Bildliste ersetzt (Farbwechsel/Variante) oder gallery.js hat die Darstellung gewechselt: neu aufbauen, erstes Bild
    const mo = new MutationObserver((records) => {
      const listChanged = records.some((r) => r.type === 'childList' && r.target.matches && r.target.matches('[data-swiper-container]'));
      const classChanged = records.some((r) => r.type === 'attributes');
      if (listChanged && track) { detach(); attach(); return; }
      if (classChanged) attach();
    });
    const ul = gallery.querySelector('[data-swiper-container]');
    if (ul) {
      mo.observe(ul, { childList: true });
      mo.observe(ul, { attributes: true, attributeFilter: ['class'] });
    }
    attach();
  }

  const start = () => document.querySelectorAll('gallery-section[data-product-page]').forEach((s) => {
    if (s.dataset.suGal) return;
    s.dataset.suGal = '1';
    // gallery.js richtet die Liste beim Verbinden ein; danach starten
    if (customElements.get('gallery-section')) init(s);
    else customElements.whenDefined('gallery-section').then(() => requestAnimationFrame(() => init(s)));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
